module.exports = __webpack_public_path__ + "static/media/community-support.44ea0209.svg";